import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { ExpectedBillModel } from '../models/expected-bill.model';
import { map, catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExpectedBillService {

  constructor(private http: HttpClient, private config: ConfigService) { }

  public GetExpectedBills(): Observable<Array<ExpectedBillModel>> {
    return this.http.get<Array<ExpectedBillModel>>(this.config.getApiRoute('api/v3/client-portal/expected-bills')).pipe(
        map(data => {
            return data;
        }),
        catchError((err: HttpErrorResponse) => {
            return throwError(err.error.message);
        }));
    }
  
public GetExpectedBill(expected_bill_id: string): Observable<ExpectedBillModel> {
    return this.http.get<ExpectedBillModel>(this.config.getApiRoute('api/v3/client-portal/expected-bills/'+ expected_bill_id)).pipe(
        map(data => {
            return data;
        }),
        catchError((err: HttpErrorResponse) => {
            return throwError(err.error.message);
        }));
    }

  public SaveExpectedBill(argument: ExpectedBillModel): Observable<ExpectedBillModel> {
    return this.http.put<ExpectedBillModel>(this.config.getApiRoute('api/v3/client-portal/expected-bills/' + argument.id), argument).pipe(
        map(data => {
            return data;
        }),
        catchError((err: HttpErrorResponse) => {
            return throwError(err.error.message);
        }));
    }
}